export * from './lib/profile.module';
